module.exports = __webpack_public_path__ + "static/img/pdf.a57d260c.png";